import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-term-condition',
  templateUrl: './term-condition.component.html',
  styleUrls: ['./term-condition.component.css']
})
export class TermConditionComponent implements OnInit {
  pdfSrc: string;
  messages: Array<string> = [];

  constructor(public  translateService: TranslateService) {
  }

  ngOnInit() {
    let language = 'en';
    if (window.localStorage.getItem('userPrefLang') && window.localStorage.getItem('userPrefLang') !== '') {
      language = window.localStorage.getItem('userPrefLang');
    } else {
      this.translateService.use('en');
    }

    this.pdfSrc = './../../../assets/termsconditions/' + language + '.pdf';
  }

}
